import { handleResponse } from './handleResponse';
import { displayError } from './displayError';
import { updateButton } from './updateButton';
import { forwardToBasket } from './forwardToBasket';
import { GTM_productFromPage } from '../tracking_scripts/tag_manager/events';

/**
 * Adds a non-personalised product to the basket.
 * @param {HTMLButtonElement} button - The 'Add to basket' button event listener.
 * @param {number} productId - The ID of the product being added.
 * @param {string} [productName] - The name of the product being added, if available.
 * @param {string} productType - The type of product being added.
 * @param {number} quantity - The amount of products being added.
 * @param {string} depositPrice - The deposit price if present.
 */
export function addProductToBasket(
	button: HTMLButtonElement,
	productId: number,
	productName: string | undefined,
	productType: string,
	quantity: number,
	depositPrice: string | null,
): void {
	void productType;

	// Package data into an object
	const data = {
		productId: productId,
		productType: productType,
		productName: productName,
		qty: quantity,
		isPersonalised: false,
		isGift: false,
		depositPrice: depositPrice ? depositPrice : null,
	};

	// Update the button to inform the user that their request is processing

	updateButton(button, true, false, depositPrice);

	if (productType === 'pre_mixed_wine_cases') {
		// Send the user to the mini shop / basket page, no data fetch required.
		GTM_productFromPage(productId, Number(quantity), productName, null, null, null);
		forwardToBasket(productId, quantity);
	} else {
		// All other product types, send the data via Fetch API to the backend.
		fetch(
			`${window.serverData.contextPath}/basket/ajaxAdd?${new URLSearchParams(data as any)}`,
			{
				method: 'GET', // Adjust to POST if needed
			},
		)
			.then((response) => response.json())
			.then((jsonResponse) =>
				handleResponse(
					jsonResponse,
					productId,
					productType,
					quantity,
					button,
					depositPrice,
				),
			)
			.catch(() => displayError('An error occurred while adding the product to the basket.'));
	}
}
